export const deleteFilterCopy = {
  header: '',
  warning: '',
  successToast: '',
};
